import React, { useRef } from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { useFirestoreConnect, isLoaded } from 'react-redux-firebase';

import { useTheme } from '../../ThemeContext';

import Helmet from '../../components/Helmet';
import LoadingData from '../../components/LoadingData';
import Header from '../../components/Header';
import Sider from '../../components/Sider';
import ApiDescription from '../../components/ApiDescription';

import {
  Section,
  Wrapper,
  Content,
  Panel,
  PanelInner,
  Information,
  Center,
  Text,
  Box,
} from './ApiDescriptionPage.style';

const ApiDescriptionPage = () => {
  const apiDescriptionRef = useRef();
  const intl = useIntl();
  const theme = useTheme();
  const apiDescription = useSelector(
    (state) => state.firestore.ordered['apiDescription']
  );

  const handleScrollEventListener = (event) =>
    apiDescriptionRef.current &&
    apiDescriptionRef.current.handleScrollEventListener(event);

  const firestoreConnect = [];
  firestoreConnect.push({
    collection: 'apiDescription',
    orderBy: [['createdAt', 'desc']],
    limit: 1,
    storeAs: 'apiDescription',
  });
  useFirestoreConnect(firestoreConnect);

  const renderInformation = (information) => {
    return (
      <Center>
        <Information theme={theme.content.information.default}>
          <Text>{information}</Text>
        </Information>
      </Center>
    );
  };

  const renderPanelBox = () => {
    return (
      <Box>
        <ApiDescription ref={apiDescriptionRef} data={apiDescription[0]} />
      </Box>
    );
  };

  return (
    <>
      <Helmet
        title={intl.formatMessage({ id: 'PAGE_TITLE.API_DESCRIPTION' })}
      />
      <Section>
        <Sider />
        <Wrapper>
          <Header
            title={intl.formatMessage({ id: 'PAGE_TITLE.API_DESCRIPTION' })}
          />
          <Content onScroll={(event) => handleScrollEventListener(event)}>
            <Panel theme={theme.content.panel.default}>
              <PanelInner>
                {isLoaded(apiDescription) ? (
                  !(apiDescription && apiDescription.length > 0) ? (
                    renderInformation(
                      intl.formatMessage({
                        id: `API_DESCRIPTION.NO_API_DOCUMENT`,
                      })
                    )
                  ) : (
                    renderPanelBox()
                  )
                ) : (
                  <LoadingData fullmode={true} />
                )}
              </PanelInner>
            </Panel>
          </Content>
        </Wrapper>
      </Section>
    </>
  );
};

export default ApiDescriptionPage;
